import { observer } from 'mobx-react';
import { Title } from 'Mri.Web.Common';
import * as React from 'react';
import { BsBoxArrowUpRight } from '@react-icons/all-files/bs/BsBoxArrowUpRight';
import { BsChatSquareDots } from '@react-icons/all-files/bs/BsChatSquareDots';
import { BsPhone } from '@react-icons/all-files/bs/BsPhone';
import { Route, RouteComponentProps } from 'react-router';

export interface IContactUsViewProps extends RouteComponentProps<undefined> {}

@observer
export class ContactUsView extends React.Component<IContactUsViewProps> {
    public render() {
        return (
            <div className="container-fluid h-100" id="not-found">
                <Title>Contact Us</Title>

                <div className="row justify-content-center">
                    <div className="col-md-4 col-xl-3 text-center pt-5 d-flex">
                        <div className="card">
                            <div className="card-body text-center h-100">
                                <BsPhone className="f-30" />

                                <p>
                                    <strong>Call Customer Support</strong>
                                </p>

                                <p>Give global support a call to help out with any issues you may be experiencing.</p>
                            </div>

                            <div className="card-footer border-0">
                                <a className="btn btn-link" href="tel:8556744878">
                                    (855) 674-4878
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-xl-3 text-center pt-5 d-flex">
                        <div className="card">
                            <div className="card-body text-center h-100">
                                <BsChatSquareDots className="f-30" />

                                <p>
                                    <strong>Contact Customer Support</strong>
                                </p>

                                <p>Use our support channels to get in touch with customer support.</p>
                            </div>

                            <div className="card-footer border-0">
                                <a className="btn btn-primary" href="https://support.mri-inc.net">
                                    {' '}
                                    <BsBoxArrowUpRight /> Support
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
